// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".role-permissions__title[data-v-0d0cb323] {\n  display: inline;\n  vertical-align: top;\n  font-weight: bold;\n}", ""]);
// Exports
module.exports = exports;
